import { Button } from "@mui/material";
import React from "react";

const CommanButton = ({ label, style, onClickButton }) => {
  return (
    <Button variant="contained" sx={style} onClick={onClickButton}>
      {label}
    </Button>
  );
};

export default CommanButton;
